import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initAppIcon } from "@/lib/pwa";

if (localStorage.getItem("pnl_capture") === "1") document.body.classList.add("capture-mode");

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => initAppIcon());
  navigator.serviceWorker.addEventListener("message", (e) => e.data?.type === "navigate" && window.location.assign(e.data.url));
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
